"use client";

import { useState } from "react";

const testimonials = [
  { name: "Janice Marquardt",         role: "Passwall Solutions · Individual Consultant",       initials: "JM", body: "I think this is a good tool, yes. Especially for businesses without an existing spend analysis tool or without tools that are integrated into their ERP, etc., this is a great tool to turn data into actionable insights. I would actually recommend it more for smaller businesses just starting to work their way into strategic instead of transactional procurement." },
  { name: "Matías Guarello Wilhelmy", role: "Independent Logistics Consultant | SCMDOJO Expert",                  initials: "MW", body: 'SENSEI is looking awesome! I just ran an Ask for "Ocean Freight Procurement Strategy," which is one of the areas I personally know best. I\'m truly impressed by the output, including speed, level of detail, and strategic logic and approach. I have been using it in the scope of my Consulting engagement. It\'s a very good sparring partner indeed and the answers are accurate.' },
  { name: "Strahinja Jovanovic",      role: "Senior Supply Chain Manager · Wolt",               initials: "SJ", body: "The way it handles supply chain-specific queries is impressive. I tested it with real scenarios from my day-to-day (inventory optimization, demand planning logic, supplier evaluation frameworks) and the outputs were genuinely useful — not generic ChatGPT-level answers, but responses that show real SC depth. The UX is clean and intuitive. This has serious potential. The SC industry desperately needs tools like this, purpose-built, not retrofitted." },
  { name: "Andy Wood",                role: "Consultant at Hatmill · Supply Chain & Logistics", initials: "AW", body: "Thanks to you too, really good to see the product, we were genuinely impressed at first glance." },
  { name: "Gordana Vrcelj",           role: "CSCL",                                             initials: "GV", body: "SENSEI AI is truly an excellent tool, and I believe you will continue to develop it while keeping pace with evolving industry trends. What stands out to me is that it can be equally valuable for both experienced professionals and juniors in their daily work. In a market flooded with AI tools, SENSEI stands out because its approach is built on real-world expertise and practical knowledge rather than pure theory." },
  { name: "Saurabh Dass",             role: "Practitioner",                                     initials: "SD", body: "Just tried out your product (free tier, 30k tokens), compared it with Claude (max) deep research. The diagrams and explanations seem really fast and crystal-clear with far more specific info than Claude so far." },
];

const allCards = [...testimonials, ...testimonials];

function TestimonialCard({ t }: { t: typeof testimonials[0] }) {
  const [expanded, setExpanded] = useState(false);
  const isLong = t.body.length > 220;

  return (
    <article className={`testimonial${expanded ? " expanded" : ""}`}>
      <div className="t-head">
        <div className="t-avatar">{t.initials}</div>
        <div className="t-meta">
          <div className="t-name">{t.name}</div>
          <div className="t-role">{t.role}</div>
        </div>
      </div>
      <div className="t-quote">
        <p className={`t-body${isLong && !expanded ? " short" : ""}`}>{t.body}</p>
      </div>
      {isLong && (
        <button className="t-more" type="button" onClick={() => setExpanded((v) => !v)}>
          {expanded ? "See less ←" : "See more →"}
        </button>
      )}
    </article>
  );
}

export function TestimonialsSection() {
  return (
    <section className="marquee-section">
      <div className="marquee-head">
        <div className="sec-eyebrow">Testimonials</div>
        <h2 className="sec-title">
          What practitioners say about <span className="grad-text">sensei.</span>
        </h2>
      </div>

      <div className="marquee-viewport">
        <div className="marquee-track">
          {allCards.map((t, i) => (
            <TestimonialCard key={`${t.name}-${i}`} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
}
